import { Routes } from '@angular/router';
import { GlobalAdministratorRoleGuard } from '@next/core-lib/authorization';
import { ChainPartnerRoleGuard } from './shared/guards/chain-partner-role.guard';
import { ArablePartnerHubRoleGuard } from './shared/guards/arable-partner-hub-role.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'upload-file',
    pathMatch: 'full',
  },
  {
    path: 'dashboard',
    redirectTo: 'upload-file',
    pathMatch: 'full',
  },
  {
    path: 'upload-file',
    loadComponent: () =>
      import('./upload-file/components/upload-file.component').then((m) => m.UploadFileComponent),
    canActivate: [ArablePartnerHubRoleGuard],
  },
  {
    path: 'uploads-overview',
    loadComponent: () =>
      import('./upload-file/components/uploads-overview.component').then(
        (m) => m.UploadsOverviewComponent,
      ),
    canActivate: [GlobalAdministratorRoleGuard],
  },
  {
    path: 'chain-partner-dashboard',
    loadComponent: () =>
      import('./chain-partner-dashboard/chain-partner-dashboard.component').then(
        (m) => m.ChainPartnerDashboardComponent,
      ),
    canActivate: [ChainPartnerRoleGuard],
  },
  {
    path: 'chain-partners',
    loadComponent: () =>
      import('./chain-partners/components/chain-partner-overview.component').then(
        (m) => m.ChainPartnerOverviewComponent,
      ),
    canActivate: [ArablePartnerHubRoleGuard],
  },
  {
    path: 'concept-yield-values',
    loadComponent: () =>
      import('./concept-yield-values/components/concept-yield-values.component').then(
        (m) => m.ConceptYieldValuesComponent,
      ),
    canActivate: [ArablePartnerHubRoleGuard],
  },
  {
    path: 'quality-properties',
    loadComponent: () =>
      import('./quality-properties/components/quality-properties.component').then(
        (m) => m.QualityPropertiesComponent,
      ),
    canActivate: [GlobalAdministratorRoleGuard],
  },
  {
    path: 'concepts',
    loadComponent: () =>
      import('./concepts/components/concept-overview.component').then(
        (m) => m.ConceptOverviewComponent,
      ),
    canActivate: [GlobalAdministratorRoleGuard],
  },
  {
    path: 'home',
    loadComponent: () => import('./home/home.component').then((m) => m.HomeComponent),
    canActivate: [ArablePartnerHubRoleGuard],
  },
];
